import React from "react";
import Doller from "../../assets/images/doller.png";

const InputPrePostBtnComponent = ({
  label,
  secondLabel,
  type,
  placeholder,
  value,
  name,
  required,
  handleChange,
  postOne,
  postTwo,
  handlePostClick,
  icon,
  postType,
  disabled
}) => {
  return (
    <>
      <div className="mx-2 my-1">
        <label
          htmlFor="website-admin"
          className="mb-1 mb-sm-1 mb-md-1 mb-lg-1 text-sm font-medium font-semibold"
          style={{ color:'#a7a7a7'}}
        >
          {label}
        </label>
        
        <div className="flex ">
       
          {postType == "ResetInc" && (
            <span
              className="rounded inline-flex"
             
              // background: #262E3A; 202531
            >
              <span
                className="inline-flex rounded-s items-center px-3 text-xs text-white cursor-pointer  font-semibold 
              "
              style={{ backgroundColor: value == 0 ? "rgb(47 69 83)" : "rgb(15 33 46)" }}
                onClick={(e) => {
                  handlePostClick(name, value ,"reset");
                }}
              >
               Reset
              </span>
              <span
                className="inline-flex rounded-e items-center px-4 text-xs cursor-pointer font-semibold"
               style={{ backgroundColor: value != 0 ? "rgb(47 69 83)" : "rgb(15 33 46)", color: value != 0 ? "white" : "gray" }}
                onClick={(e) => {
                  
                  handlePostClick(name, value , "increase");
                }}
              >
               Increase_By
              </span>
            </span>
          )}
          <div className="flex items-center relative w-full ms-2">
            <input
              type={type}
              name={name}
              id="website-admin"
              value={value}
              required={required}
              onChange={(e) => {
                handleChange(e);
              }}
              className="relative rounded form-control flex-1 min-w-0 w-full text-sm p-3/2 "
              placeholder={placeholder}
              style={{
                backgroundColor: "rgb(15 33 46)",
                color: "white",
                border: "1px solid rgb(47 69 83)",
              }}
              disabled={disabled}
            />
            {icon && (
              <span className="absolute end-2 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer">
                %
              </span>
            )}
          </div>

         
        </div>
      </div>
    </>
  );
};

export default InputPrePostBtnComponent;
